const HEX_COLOR_WITHOUT_HASH_REGEXP = /^(?:[0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;

export function normalizeHexColor(color: string | null | undefined): string | null {
  if (!color) {
    return null;
  }

  if (HEX_COLOR_WITHOUT_HASH_REGEXP.test(color)) {
    return `#${color}`;
  }

  return color;
}
